// utilizzata per quasi tutti i componenti che contengono Typeahead 
export const handleTabSelect = (e, options, setFieldValue, fieldID, fieldDesc, setDefault, fieldExtra) => {
    if (e.key === 'Tab') {
        const selected = options.find(o => o.descrizione === e.target.value);
        if (selected) {
            if (setFieldValue) {
                setFieldValue(fieldID, selected.id);
                setFieldValue(fieldDesc, selected.descrizione);
            }
            if (setDefault)
                setDefault([{ id: selected.id, descrizione: selected.descrizione }]);
            if (fieldExtra)
                setFieldValue(fieldExtra, selected.extra);
            return [selected];
        }
        return [];
    }
};

// utilizzata da EsameSelector.jsx
export const handleTabSelectLikeDesc = (e, options) => {
    if (e.key === 'Tab') {
        let val = e.target.value;
        if (val.includes("-")) {
            val = e.target.value.split("-")[1].trim();
        }
        const selected = options.find(o => o.descrizione.includes(val.substring(0, 25)));
        if (selected) {
            return [selected];
        }
        return [];
    }
};